import { Navigate, Outlet } from 'react-router-dom';
import { isOperatorUser } from '@/utils/auth';

export default function AdminGuard() {
  return isOperatorUser() ? <Navigate to="/rig_well" replace /> : <Outlet />;
}
